import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/proflow360/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/proflow360/src/app/components/LandingFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/proflow360/src/components/ui/AppImage.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/proflow360/src/i18n/react.tsx");
